import { render, staticRenderFns } from "./input-text.vue?vue&type=template&id=1a6fc32a&scoped=true"
import script from "./input-text.vue?vue&type=script&lang=js"
export * from "./input-text.vue?vue&type=script&lang=js"
import style0 from "./input-text.vue?vue&type=style&index=0&id=1a6fc32a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6fc32a",
  null
  
)

export default component.exports